import { Box, Image } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import cnyGoldBlessing from '../images/cny-gold-blessing.png';
import { isExpiredNewYear } from '../utils';

/**
 * @description 金元寶相關祝福圖示元件
 * @returns {JSX.Element} 金元寶祝福圖示
 */
const CnyGoldBlessing = () => {
  const currentCurrency = useSelector((state) => state.isWalletCurrency);

  // 若已過新年裝飾結束日期，則不顯示金元寶祝福元件
  if (isExpiredNewYear()) return null;

  // 若當前幣別為馬來幣，則不顯示金元寶祝福元件
  if (currentCurrency === 'MYR') return null;

  return (
    <Box
      pointerEvents={'none'}
      position="absolute"
      right={{ base: '-12rem', xl: '-5rem' }}
      zIndex={10}
      display={{ base: 'none', lg: 'block' }}
    >
      <Image
        src={cnyGoldBlessing}
        alt="CNY Gold Blessing"
        transform={{ base: 'scale(0.5)', lg: 'scale(1)' }}
      />
    </Box>
  );
};

export default CnyGoldBlessing;
